/**
 * Создает менеджер для управления автоскроллом
 * @param {Function} getElement - функция, возвращающая DOM элемент
 * @param {number} step - шаг скролла в пикселях
 * @param {Function} onUpdate - callback для обновления состояния кнопок
 * @returns {Object} - объект с методами управления скроллом
 */
export function createScrollManager(getElement, step = 150, onUpdate = null) {
    let scrollTimer = null;
    let scrollDirection = null;

    /**
     * Обновляет видимость кнопок скролла
     */
    const updateScrollButtons = () => {
        const el = getElement();

        if (!el) {
            onUpdate?.(false, false);
            return;
        }

        const hasScroll = el.scrollWidth > el.clientWidth + 1;
        const showLeft = hasScroll && el.scrollLeft > 0;
        const showRight = hasScroll && el.scrollLeft + el.clientWidth < el.scrollWidth - 1;

        onUpdate?.(showLeft, showRight);
    };

    /**
     * Запускает автоматический скролл
     * @param {string} direction - 'left' или 'right'
     */
    const startAutoScroll = (direction) => {
        const el = getElement();
        if (!el) return;

        stopAutoScroll();

        scrollDirection = direction;
        scrollTimer = setInterval(() => {
            const currentEl = getElement();
            if (!currentEl) {
                stopAutoScroll();
                return;
            }

            const maxScrollLeft = currentEl.scrollWidth - currentEl.clientWidth;
            let nextLeft = currentEl.scrollLeft + (direction === 'left' ? -step : step);

            if (nextLeft <= 0) nextLeft = 0;
            if (nextLeft >= maxScrollLeft) nextLeft = maxScrollLeft;

            currentEl.scrollTo({
                left: nextLeft,
                behavior: 'smooth',
            });

            updateScrollButtons();

            const atStart = nextLeft <= 0;
            const atEnd = nextLeft >= maxScrollLeft;

            if ((direction === 'left' && atStart) || (direction === 'right' && atEnd)) {
                stopAutoScroll();
            }
        }, 16);
    };

    /**
     * Останавливает автоматический скролл
     */
    const stopAutoScroll = () => {
        if (scrollTimer) {
            clearInterval(scrollTimer);
            scrollTimer = null;
        }
        scrollDirection = null;
    };

    /**
     * Очищает все ресурсы
     */
    const destroy = () => {
        stopAutoScroll();
    };

    return {
        updateScrollButtons,
        startAutoScroll,
        stopAutoScroll,
        destroy,
    };
}